// pages/CongesPage.jsx
import React from 'react';

export default function CongesPage() {
  return (
    <div className="text-gray-800 text-lg font-semibold">
      📅 Suivi et demande de congés (vue en cours de développement)
    </div>
  );
}
